<template>
  <div
    v-if="interactive"
    class="slide-card__actions"
  >
    <button
      v-if="!isDeleted"
      type="button"
      class="slide-action-btn slide-action-btn--delete"
      title="Delete slide"
      @click.stop="$emit('delete')"
    >
      <img
        class="icon-svg"
        src="@/assets/icons/trash.svg"
        alt="Delete"
      >
    </button>
    <button
      v-else
      type="button"
      class="slide-action-btn slide-action-btn--restore"
      title="Restore slide"
      @click.stop="$emit('restore')"
    >
      <img
        class="icon-svg"
        src="@/assets/icons/restore.svg"
        alt="Restore"
      >
    </button>
  </div>
</template>

<script setup lang="ts">

defineProps<{
  isDeleted: boolean;
  interactive: boolean;
}>();

defineEmits<{
  (e: 'delete'): void;
  (e: 'restore'): void;
}>();
</script>

<style scoped>
.slide-card__actions {
  position: absolute;
  top: 4px;
  right: 4px;
  display: flex;
  gap: 4px;
}

.slide-action-btn {
  width: 24px;
  height: 24px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(0, 0, 0, 0.1);
  background: rgba(255, 255, 255, 0.9);
  cursor: pointer;
  padding: 0;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  transition: all 0.2s ease;
}

.slide-action-btn:hover {
  background: #ffffff;
  transform: scale(1.1);
}

.icon-svg {
  width: 14px;
  height: 14px;
  stroke: currentColor;
}

.slide-action-btn--delete {
  color: #ef4444;
}

.slide-action-btn--delete:hover {
  background: #fef2f2;
  border-color: #fecaca;
}

.slide-action-btn--restore {
  color: #2563eb;
}

.slide-action-btn--restore:hover {
  background: #eff6ff;
  border-color: #bfdbfe;
}
</style>
